<template><div><h1>VUX 发布日志</h1>
<h2>next (未发布)</h2>
<h3>Search</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加属性 type</span></li></ul>
<h3>Swipeout</h3>
<ul><li><span style="font-size:15px;"><span class="change change-feature">feature</span>  添加属性 disabled</span></li></ul>
<h2><a href="/zh-CN/changelog/v2.10.1.html">v2.10.1</a></h2>
<h3>XTextarea</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复回车符导致的字符计算错误 <a href="https://github.com/airyland/vux/issues/3784" target="_blank">#3784</a> </span></li></ul>
<h2><a href="/zh-CN/changelog/v2.9.4.html">v2.9.4</a></h2>
<h3>Picker</h3>
<ul><li><span style="font-size:15px;"><span class="change change-fix">fix</span>  修复多级联动模式下，快速滚动多个项，取值不正确</span></li></ul>
<h3>Tab</h3>
<ul><li><span style="font-size:15px;"><span class="change change-change">change</span>  修复 tab的父级width没有100%或者有padding 滚动造成文字跟横杠错位问题 <a href="https://github.com/airyland/vux/issues/2850" target="_blank">#2850</a> </span></li></ul>
<h2><a href="/zh-CN/changelog/2.9.3.html">2.9.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.9.2.html">v2.9.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.9.1.html">v2.9.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.9.0.html">v2.9.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.8.1.html">v2.8.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.8.0.html">v2.8.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.9.html">v2.7.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.8.html">v2.7.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.7.html">v2.7.7</a></h2>
<h2><a href="/zh-CN/changelog/2.7.6.html">2.7.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.6.html">v2.7.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.5.html">v2.7.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.4.html">v2.7.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.3.html">v2.7.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.2.html">v2.7.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.1.html">v2.7.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.7.0.html">v2.7.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.5.html">v2.6.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.4.html">v2.6.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.3.html">v2.6.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.2.html">v2.6.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.1.html">v2.6.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.6.0.html">v2.6.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.12.html">v2.5.12</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.11.html">v2.5.11</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.10.html">v2.5.10</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.9.html">v2.5.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.8.html">v2.5.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.7.html">v2.5.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.6.html">v2.5.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.5.html">v2.5.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.4.html">v2.5.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.3.html">v2.5.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.2.html">v2.5.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.1.html">v2.5.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.5.0.html">v2.5.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.4.1.html">v2.4.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.4.0.html">v2.4.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.8.html">v2.3.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.7.html">v2.3.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.6.html">v2.3.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.5.html">v2.3.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.4.html">v2.3.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.3.html">v2.3.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.2.html">v2.3.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.3.1.html">v2.3.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.2.html">v2.2.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1.html">v2.2.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.8.html">v2.2.1-rc.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.7.html">v2.2.1-rc.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.6.html">v2.2.1-rc.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.4.html">v2.2.1-rc.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.3.html">v2.2.1-rc.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.2.html">v2.2.1-rc.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.1-rc.1.html">v2.2.1-rc.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.2.0.html">v2.2.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.14.html">v2.1.1-rc.14</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.13.html">v2.1.1-rc.13</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.12.html">v2.1.1-rc.12</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.11.html">v2.1.1-rc.11</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.10.html">v2.1.1-rc.10</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.9.html">v2.1.1-rc.9</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.8.html">v2.1.1-rc.8</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.7.html">v2.1.1-rc.7</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.6.html">v2.1.1-rc.6</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.5.html">v2.1.1-rc.5</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.4.html">v2.1.1-rc.4</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.3.html">v2.1.1-rc.3</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.2.html">v2.1.1-rc.2</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.1-rc.1.html">v2.1.1-rc.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0.html">v2.1.0</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.51.html">v2.1.0-rc.51</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.50.html">v2.1.0-rc.50</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.49.html">v2.1.0-rc.49</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.48.html">v2.1.0-rc.48</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.47.html">v2.1.0-rc.47</a></h2>
<h2><a href="/zh-CN/changelog/v2.1.0-rc.46.html">v2.1.0-rc.46</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.14.html">v2.0.14</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.1.html">v2.0.1</a></h2>
<h2><a href="/zh-CN/changelog/v2.0.0.html">v2.0.0</a></h2>
</div></template><script>
export default {
  head: {"title":"VUX 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// changelog-192.vue?49569ef2